// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"f822d4e2","447":"3ac4d9e0","486":"f822d4e2","758":"7d510384","772":"f822d4e2"}[chunkId] + ".chunk.css";
};